// Thanh lọc & tìm kiếm: nội dung/người gửi, postId, khoảng ngày, trạng thái duyệt,
// toggle chưa trả lời, export
import React from "react";
import { Input, DatePicker, Switch, Button, Tooltip, Space, Select, Badge } from "antd";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faFileCsv, faRotate, faBan, faGaugeHigh } from "@fortawesome/free-solid-svg-icons";

const { RangePicker } = DatePicker;

export default function CommentFilterBar({
    q,
    postId,
    unanswered,
    status,
    pendingTotal,
    dateRange,
    loading,
    onSearch,
    onPostId,
    onToggleUnanswered,
    onStatusChange,
    onDateChange,
    onExport,
    onRefresh,
    onOpenBannedWords,
    onOpenRateLimit,
}) {
    return (
        <div className="flex flex-wrap items-center gap-3 mb-4 bg-surface p-3 rounded-lg border border-line">
            {/* w-full trên mobile để input không tràn màn hình hẹp */}
            <Input.Search
                allowClear
                placeholder="Tìm nội dung, trả lời hoặc tên người gửi…"
                className="w-full sm:w-[280px]"
                defaultValue={q}
                onSearch={onSearch}
            />
            <Input.Search
                allowClear
                placeholder="Lọc theo postId (vd: 12, 10)"
                className="w-full sm:w-[200px]"
                defaultValue={postId}
                onSearch={onPostId}
            />
            <RangePicker
                value={dateRange}
                onChange={onDateChange}
                format="DD/MM/YY"
                placeholder={["Từ ngày", "Đến ngày"]}
                className="w-full sm:w-auto"
            />
            <Badge count={pendingTotal || 0} size="small" offset={[-4, 2]}>
                <Select
                    value={status || ""}
                    onChange={onStatusChange}
                    style={{ width: 140 }}
                    options={[
                        { value: "", label: "Tất cả trạng thái" },
                        { value: "pending", label: "Chờ duyệt" },
                        { value: "approved", label: "Đã duyệt" },
                    ]}
                />
            </Badge>
            <Tooltip title="Chỉ hiện bình luận chưa có admin trả lời">
                <span className="flex items-center gap-2 text-sm">
                    <Switch checked={unanswered} onChange={onToggleUnanswered} />
                    Chưa trả lời
                </span>
            </Tooltip>
            <Space className="ml-auto" wrap>
                <Tooltip title="Cấu hình từ cấm: comment chứa từ cấm tự vào chờ duyệt">
                    <Button icon={<FontAwesomeIcon icon={faBan} />} onClick={onOpenBannedWords}>
                        Từ cấm
                    </Button>
                </Tooltip>
                <Tooltip title="Giới hạn số bình luận mỗi user gửi trong 1 giờ (chống spam)">
                    <Button icon={<FontAwesomeIcon icon={faGaugeHigh} />} onClick={onOpenRateLimit}>
                        Giới hạn
                    </Button>
                </Tooltip>
                <Tooltip title="Tải lại">
                    <Button
                        icon={<FontAwesomeIcon icon={faRotate} />}
                        loading={loading}
                        onClick={onRefresh}
                    />
                </Tooltip>
                <Button icon={<FontAwesomeIcon icon={faFileCsv} />} onClick={onExport}>
                    Xuất CSV
                </Button>
            </Space>
        </div>
    );
}
